// Para gösterimi ve girişi (TRY). Sunucu tutarları kuruş (integer) saklar;
// ekranda "1.250,00 ₺" yazılır, girişte "1250", "1.250,5", "1250.50" kabul edilir.

const FORMATTER = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Kuruş → "1.250,00 ₺". Geçersizse "—". */
export function formatMoney(kurus, { sign = false } = {}) {
  const n = Number(kurus);
  if (!Number.isFinite(n)) return "—";
  const text = `${FORMATTER.format(Math.abs(n) / 100)} ₺`;
  if (n < 0) return `−${text}`;
  return sign && n > 0 ? `+${text}` : text;
}

/** Kuruş → giriş kutusuna yazılacak TL metni ("1250,5" değil "1250,50"; tam sayıda "1250"). */
export function kurusToInput(kurus) {
  const n = Number(kurus);
  if (!Number.isFinite(n)) return "";
  if (n % 100 === 0) return String(n / 100);
  return (n / 100).toFixed(2).replace(".", ",");
}

/**
 * TL metni → kuruş (integer). Boş ya da geçersizse null.
 * Türkçe yazımda "." binlik, "," ondalık ayırıcıdır; yalnız "." varsa ve
 * ardından 1–2 hane geliyorsa ondalık sayılır ("1250.50").
 */
export function parseMoneyInput(text) {
  let s = String(text ?? "").replace(/[\s₺TL]/gi, "").trim();
  if (!s) return null;
  if (s.includes(",")) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (/^\d+\.\d{1,2}$/.test(s)) {
    // "1250.5" → ondalık
  } else {
    s = s.replace(/\./g, "");
  }
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  return Math.round(Number(s) * 100);
}

export const PAYMENT_METHOD_LABELS = {
  cash: "Nakit",
  card: "Kart",
  transfer: "Havale / EFT",
};
